require('./bootstrap');
window.Util = require('./util');
